/**
 * BankBadge.tsx — a small "10001 · Saidapet UCB" identifier with the bank
 * name in bold and the org_id rendered as a faint chip beside it.
 */

import React from 'react';

interface Props {
	orgId: number;
	orgName: string;
}

export default function BankBadge({ orgId, orgName }: Props) {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
			<span
				style={{
					fontWeight: 600,
					color: 'var(--text)',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					maxWidth: 280,
				}}
				title={orgName}
			>
				{orgName}
			</span>
			<span style={{ fontSize: 11, color: 'var(--text-faint)', fontVariantNumeric: 'tabular-nums' }}>
				ID {orgId}
			</span>
		</div>
	);
}
